"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:6.1.5'] && _();
}
catch (e) { }
